/**
 * Parse a bracket-style string to an usable object.
 */
const recursiveUnbracket = (str: string): string[] =>
  str.split("[").map((s) => (s.endsWith("]") ? s.slice(0, -1) : s));

export default recursiveUnbracket;
